import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, PenTool, Lightbulb, AlertCircle, Check, X, ChevronDown, Award } from 'lucide-react';

const PUZZLES = {
  A1: [
    { id: 'sanomi', letters: ['S', 'A', 'N', 'O', 'M', 'I'], answers: ['maison', 'amis', 'main', 'soin', 'nom', 'son', 'sain', 'ami'] },
    { id: 'relapr', letters: ['R', 'E', 'L', 'A', 'P', 'R'], answers: ['parler', 'perle', 'rare', 'par', 'larme', 'réel', 'rap'] },
    { id: 'cesole', letters: ['C', 'E', 'S', 'O', 'L', 'E'], answers: ['école', 'sol', 'ose', 'col', 'les', 'sel', 'socle', 'sole'] },
    { id: 'niadrj', letters: ['N', 'I', 'A', 'D', 'R', 'J'], answers: ['jardin', 'raid', 'air', 'nid', 'radin', 'rien', 'din', 'ira'] },
    { id: 'eflmial', letters: ['E', 'F', 'L', 'M', 'I', 'A', 'L'], answers: ['famille', 'fille', 'film', 'ami', 'mal', 'aile', 'lime', 'fil'] },
    { id: 'evoagy', letters: ['E', 'V', 'O', 'A', 'G', 'Y'], answers: ['voyage', 'voie', 'age', 'ego', 'gave', 'yoga', 'ave', 'oye'] },
    { id: 'cucnisi', letters: ['C', 'U', 'E', 'N', 'I', 'S', 'I'], answers: ['cuisine', 'usine', 'une', 'ici', 'unie', 'sien', 'sein', 'ces'] },
    { id: 'muqesiu', letters: ['M', 'U', 'Q', 'E', 'S', 'I', 'U'], answers: ['musique', 'mise', 'sue', 'qui', 'mie', 'mes', 'ému', 'semi'] },
    { id: 'taublea', letters: ['T', 'A', 'U', 'B', 'L', 'E', 'A'], answers: ['tableau', 'table', 'eau', 'but', 'bel', 'bleu', 'tuile', 'aube'] },
    { id: 'pommes', letters: ['P', 'O', 'M', 'M', 'E', 'S'], answers: ['pommes', 'pose', 'somme', 'mes', 'ose', 'spe', 'mops', 'pom'] },
  ],
  A2: [
    { id: 'tariven', letters: ['T', 'A', 'R', 'I', 'V', 'E', 'N'], answers: ['arrive', 'venir', 'train', 'rien', 'vrai', 'rate', 'tire', 'aire', 'vain', 'ravi'] },
    { id: 'seursoc', letters: ['S', 'E', 'U', 'R', 'S', 'O', 'C'], answers: ['course', 'source', 'sucre', 'cours', 'roue', 'ours', 'sous', 'rose', 'euro'] },
    { id: 'pdatrse', letters: ['P', 'D', 'A', 'T', 'R', 'S', 'E'], answers: ['départ', 'perdre', 'stade', 'date', 'part', 'tard', 'drap', 'rade', 'rate'] },
    { id: 'rliaber', letters: ['R', 'L', 'I', 'A', 'B', 'E', 'R'], answers: ['libre', 'baril', 'rail', 'aire', 'lire', 'rire', 'bier', 'baie', 'bale'] },
    { id: 'tsocner', letters: ['T', 'S', 'O', 'C', 'N', 'E', 'R'], answers: ['contre', 'centre', 'notre', 'toner', 'reste', 'note', 'son', 'roc', 'ton'] },
    { id: 'hmascre', letters: ['H', 'M', 'A', 'S', 'C', 'R', 'E'], answers: ['marche', 'charme', 'sache', 'arme', 'mer', 'sac', 'rame', 'race'] },
    { id: 'etlapne', letters: ['E', 'T', 'L', 'A', 'P', 'N', 'E'], answers: ['planète', 'plante', 'lente', 'pente', 'plan', 'net', 'été', 'lane'] },
    { id: 'rformser', letters: ['R', 'F', 'O', 'M', 'S', 'E', 'R'], answers: ['former', 'forme', 'morse', 'rose', 'mer', 'fer', 'orme', 'fore'] },
    { id: 'gvaises', letters: ['G', 'V', 'A', 'I', 'S', 'E', 'S'], answers: ['visage', 'sage', 'vise', 'vase', 'avis', 'via', 'age', 'save'] },
    { id: 'dreagre', letters: ['D', 'R', 'E', 'A', 'G', 'R', 'E'], answers: ['regard', 'garde', 'grade', 'rare', 'rage', 'are', 'gare', 'rade'] },
  ],
  B1: [
    { id: 'yrsalena', letters: ['Y', 'R', 'S', 'A', 'L', 'E', 'N', 'A'], answers: ['analyser', 'nasal', 'sale', 'anse', 'réal', 'laser', 'rayon', 'saler', 'arène'] },
    { id: 'nrodermc', letters: ['N', 'R', 'E', 'O', 'D', 'R', 'E', 'M', 'C', 'P'], answers: ['comprendre', 'prendre', 'rendre', 'ordre', 'monde', 'corde', 'mode', 'mer', 'nom'] },
    { id: 'qeuxpilre', letters: ['Q', 'E', 'U', 'X', 'P', 'I', 'L', 'R', 'E'], answers: ['expliquer', 'réplique', 'pique', 'lire', 'rire', 'pile', 'pli', 'luxe'] },
    { id: 'pevodlrpe', letters: ['P', 'E', 'V', 'O', 'E', 'D', 'L', 'R', 'P', 'E'], answers: ['développer', 'révolte', 'lever', 'vélo', 'perde', 'pôle', 'père', 'rêve'] },
    { id: 'grautemnre', letters: ['G', 'R', 'A', 'U', 'T', 'E', 'M', 'N', 'R', 'E'], answers: ['argumenter', 'gérant', 'nature', 'rame', 'arme', 'tuer', 'gare', 'mur'] },
    { id: 'rsoignera', letters: ['R', 'S', 'O', 'I', 'G', 'N', 'E', 'R', 'A'], answers: ['organiser', 'raison', 'ranger', 'soigner', 'rosier', 'signe', 'noir', 'air'] },
    { id: 'tudirsce', letters: ['T', 'U', 'D', 'I', 'R', 'S', 'C', 'E'], answers: ['discuter', 'direct', 'dure', 'dire', 'suit', 'cite', 'rude', 'cure'] },
    { id: 'noucstrire', letters: ['N', 'O', 'U', 'C', 'S', 'R', 'T', 'I', 'R', 'E'], answers: ['construire', 'sortir', 'courir', 'nourri', 'route', 'rire', 'tour', 'cuire'] },
    { id: 'refhcliere', letters: ['R', 'E', 'F', 'H', 'C', 'L', 'I', 'E', 'R'], answers: ['réfléchir', 'fichier', 'relire', 'riche', 'lire', 'chef', 'rire', 'fier'] },
    { id: 'trpiaicerp', letters: ['T', 'R', 'P', 'I', 'A', 'I', 'C', 'E', 'R', 'P'], answers: ['participer', 'réparti', 'partir', 'trace', 'pair', 'acte', 'rate', 'paire'] },
  ],
  B2: [
    { id: 'tnruemagtaoni', letters: ['T', 'N', 'R', 'U', 'E', 'M', 'A', 'G', 'T', 'A', 'O', 'N', 'I'], answers: ['argument', 'image', 'ration', 'union', 'rage', 'agir', 'notion', 'montant', 'train'] },
    { id: 'ailpbrsenostie', letters: ['A', 'I', 'L', 'P', 'B', 'R', 'S', 'E', 'N', 'O', 'S', 'T', 'I', 'É'], answers: ['responsable', 'tension', 'raison', 'relation', 'plaisir', 'pression', 'stable', 'poison', 'nation', 'porter'] },
    { id: 'tafrmosinrotan', letters: ['T', 'A', 'F', 'R', 'M', 'O', 'S', 'I', 'N', 'R', 'O', 'T', 'A', 'N'], answers: ['formation', 'information', 'nation', 'transformer', 'action', 'train', 'roman', 'raison', 'format', 'motion'] },
    { id: 'ncmiutocmaoin', letters: ['N', 'C', 'M', 'I', 'U', 'T', 'O', 'C', 'M', 'A', 'O', 'I', 'N'], answers: ['communication', 'action', 'union', 'nation', 'notion', 'matin', 'commun', 'mutation', 'camion', 'main'] },
    { id: 'tpretierinotian', letters: ['T', 'P', 'R', 'E', 'T', 'É', 'R', 'I', 'N', 'O', 'T', 'I', 'A', 'N'], answers: ['interprétation', 'tension', 'porter', 'notion', 'train', 'relation', 'irritation', 'intérêt', 'partie', 'orientation'] },
    { id: 'npmetpoevedle', letters: ['N', 'P', 'M', 'E', 'T', 'P', 'O', 'É', 'V', 'E', 'D', 'L', 'E'], answers: ['développement', 'mode', 'vente', 'monde', 'temple', 'point', 'moment', 'lente', 'démon', 'enveloppe'] },
    { id: 'nsiceoncc', letters: ['N', 'S', 'I', 'C', 'E', 'O', 'N', 'C', 'C'], answers: ['conscience', 'science', 'coin', 'signe', 'sens', 'scène', 'ancien', 'union', 'notion'] },
    { id: 'etrppeocnii', letters: ['E', 'T', 'R', 'P', 'P', 'E', 'O', 'C', 'N', 'I', 'I'], answers: ['perception', 'notion', 'portion', 'point', 'option', 'récit', 'pierre', 'relation', 'position', 'orientation'] },
    { id: 'nsotiaarigno', letters: ['N', 'S', 'O', 'T', 'I', 'A', 'A', 'R', 'I', 'G', 'N', 'O'], answers: ['organisation', 'raison', 'action', 'nation', 'signal', 'orientation', 'train', 'maison', 'relation'] },
    { id: 'xneoflrei', letters: ['X', 'N', 'É', 'O', 'F', 'L', 'R', 'E', 'I'], answers: ['réflexion', 'notion', 'relation', 'fiction', 'ironie', 'fixer', 'orient', 'noir', 'lien'] },
    { id: 'hteyposehiqu', letters: ['H', 'T', 'E', 'Y', 'O', 'P', 'S', 'E', 'H', 'I', 'Q', 'U'], answers: ['hypothèse', 'psyché', 'question', 'poésie', 'histoire', 'théorie', 'physique', 'sujet', 'pensée', 'logique'] },
    { id: 'mtaerporhep', letters: ['M', 'T', 'A', 'E', 'R', 'P', 'O', 'R', 'H', 'E', 'P'], answers: ['métaphore', 'phrase', 'thème', 'peur', 'porter', 'rapport', 'terme', 'homme', 'époque', 'forme'] },
    { id: 'otaxpiernli', letters: ['O', 'T', 'A', 'X', 'P', 'I', 'E', 'R', 'N', 'L', 'I'], answers: ['exploration', 'relation', 'texte', 'point', 'nation', 'train', 'pierre', 'opinion', 'extérieur', 'action'] },
    { id: 'sinocialure', letters: ['S', 'I', 'N', 'O', 'C', 'T', 'A', 'L', 'U', 'R', 'E'], answers: ['relation', 'culture', 'social', 'nature', 'action', 'ration', 'costume', 'notion', 'centre', 'leçon', 'acteur', 'lecture'] },
    { id: 'fijutiacons', letters: ['F', 'I', 'J', 'U', 'T', 'I', 'A', 'C', 'O', 'N', 'S'], answers: ['justice', 'action', 'notion', 'confusion', 'intuition', 'faute', 'fusion', 'fonction', 'situation', 'fiction', 'société'] },
    { id: 'uteonamgirt', letters: ['U', 'T', 'E', 'O', 'A', 'N', 'M', 'G', 'I', 'R', 'T'], answers: ['montagne', 'nature', 'mouvement', 'route', 'train', 'moteur', 'image', 'avenir', 'tonnerre', 'urgence'] },
    { id: 'cioencratfno', letters: ['C', 'I', 'O', 'E', 'N', 'R', 'T', 'A', 'T', 'F', 'N', 'O'], answers: ['information', 'formation', 'narration', 'action', 'relation', 'notion', 'conférence', 'fonction', 'citation', 'forum'] },
    { id: 'viedrsupasser', letters: ['V', 'I', 'E', 'D', 'R', 'S', 'U', 'A', 'P', 'S', 'E', 'R'], answers: ['persuader', 'surprise', 'décision', 'adversaire', 'réussir', 'univers', 'service', 'désir', 'vision', 'réserve'] },
  ],
};

const LEVELS = ['A1', 'A2', 'B1', 'B2'];

const BADGES = [
  { min: 3, icon: '🧠', label: 'Bon réflexe !' },
  { min: 2, icon: '🔥', label: 'Très bon vocabulaire !' },
  { min: 1, icon: '🚀', label: 'Continue comme ça !' },
  { min: 0, icon: '💪', label: 'Essaie encore !' },
];

function getBadge(correctCount) {
  if (correctCount >= 3) return BADGES[0];
  if (correctCount >= 2) return BADGES[1];
  if (correctCount >= 1) return BADGES[2];
  return BADGES[3];
}

function PuzzleCard({ puzzle, index, onNext, isLast }) {
  const [words, setWords] = useState(['', '', '']);
  const [validated, setValidated] = useState(false);
  const [results, setResults] = useState(null);
  const [error, setError] = useState(false);
  const cardRef = useRef(null);

  const handleValidate = () => {
    const filled = words.filter(w => w.trim().length > 0);
    if (filled.length < 3) {
      setError(true);
      setTimeout(() => setError(false), 3000);
      return;
    }
    setError(false);
    const checks = words.map(w => {
      const clean = w.trim().toLowerCase();
      return { word: w.trim(), correct: clean.length > 0 && puzzle.answers.some(a => a.toLowerCase() === clean) };
    });
    setResults(checks);
    setValidated(true);
  };

  const updateWord = (idx, val) => {
    const next = [...words];
    next[idx] = val;
    setWords(next);
  };

  const correctCount = results ? results.filter(r => r.correct).length : 0;
  const badge = results ? getBadge(correctCount) : null;

  return (
    <div ref={cardRef} className="bg-white border border-[#E8E4DC] rounded-xl overflow-hidden transition-all duration-300" data-testid={`puzzle-card-${puzzle.id}`}>
      {/* Header with letters */}
      <div className="bg-[#1A2F4A] px-5 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-7 h-7 rounded-full bg-[#D4AF37]/20 text-[#D4AF37] flex items-center justify-center text-xs font-bold">
              {index + 1}
            </div>
            <p className="text-xs text-white/60 uppercase tracking-wider font-bold">Lettres</p>
          </div>
          {validated && (
            <span className="text-[10px] text-emerald-400 font-bold flex items-center gap-1" data-testid={`done-${puzzle.id}`}>
              <Check className="w-3 h-3" /> Set terminé
            </span>
          )}
        </div>
        <div className="flex justify-center gap-1.5 mt-3 flex-wrap" data-testid={`letters-${puzzle.id}`}>
          {puzzle.letters.map((l, i) => (
            <div key={i} className="w-9 h-9 rounded-lg bg-white/10 border border-white/20 text-white flex items-center justify-center text-base font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>
              {l}
            </div>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="px-5 py-4 space-y-3">
        {!validated && (
          <>
            <p className="text-xs text-[#6B4E37] italic">Forme au moins 3 mots en français avec ces lettres.</p>
            <div className="space-y-2">
              {[0, 1, 2].map(i => (
                <div key={i} className="flex items-center gap-2">
                  <span className="text-xs text-[#999] font-bold w-12">Mot {i + 1}</span>
                  <input
                    type="text"
                    value={words[i]}
                    onChange={(e) => updateWord(i, e.target.value)}
                    onKeyDown={(e) => { if (e.key === 'Enter' && i === 2) handleValidate(); }}
                    placeholder="..."
                    className="flex-1 border border-[#E8E4DC] rounded-lg px-3 py-2 text-sm text-[#1A2F4A] placeholder-[#ddd] focus:outline-none focus:border-[#D4AF37] transition-colors"
                    data-testid={`input-${puzzle.id}-${i}`}
                  />
                </div>
              ))}
            </div>
            {error && (
              <div className="flex items-center gap-1.5 text-xs text-red-500" data-testid={`error-${puzzle.id}`}>
                <AlertCircle className="w-3.5 h-3.5" />
                Écris au moins 3 mots pour voir les réponses.
              </div>
            )}
            <button
              onClick={handleValidate}
              className="w-full bg-[#1A2F4A] text-white rounded-lg py-2.5 text-xs font-bold hover:bg-[#243a58] transition-colors"
              data-testid={`validate-${puzzle.id}`}>
              Valider mes réponses
            </button>
          </>
        )}

        {/* Results */}
        {validated && results && (
          <div className="space-y-3 animate-fade-in" data-testid={`results-${puzzle.id}`}>
            {/* Word results */}
            <div className="space-y-1.5">
              {results.map((r, i) => (
                r.word && (
                  <div key={i} className={`flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium transition-all ${
                    r.correct
                      ? 'bg-emerald-50 text-emerald-700 border border-emerald-200'
                      : 'bg-red-50 text-red-400 border border-red-200'
                  }`} data-testid={`result-${puzzle.id}-${i}`}>
                    {r.correct ? <Check className="w-4 h-4" /> : <X className="w-4 h-4" />}
                    <span>{r.word}</span>
                    {r.correct && <span className="ml-auto text-[10px] opacity-60">Correct</span>}
                    {!r.correct && <span className="ml-auto text-[10px] opacity-60">Pas dans la liste</span>}
                  </div>
                )
              ))}
            </div>

            {/* Badge */}
            {badge && (
              <div className="flex items-center justify-center gap-2 bg-[#FAF7F0] border border-[#E8E4DC] rounded-lg py-3" data-testid={`badge-${puzzle.id}`}>
                <span className="text-xl">{badge.icon}</span>
                <span className="text-xs font-bold text-[#1A2F4A]">{badge.label}</span>
                <span className="text-[10px] text-[#999]">({correctCount}/3 correct{correctCount > 1 ? 's' : ''})</span>
              </div>
            )}

            {/* Tip */}
            <div className="flex items-start gap-2 bg-[#D4AF37]/5 border border-[#D4AF37]/20 rounded-lg px-4 py-3" data-testid={`tip-${puzzle.id}`}>
              <Lightbulb className="w-4 h-4 text-[#D4AF37] flex-shrink-0 mt-0.5" />
              <p className="text-xs text-[#6B4E37] leading-relaxed">
                <span className="font-bold">Astuce :</span> Cherche d'abord les mots longs, puis explore les combinaisons plus courtes.
              </p>
            </div>

            {/* Next button */}
            {!isLast && (
              <button
                onClick={onNext}
                className="w-full flex items-center justify-center gap-2 bg-[#1A2F4A] text-white rounded-lg py-2.5 text-xs font-bold hover:bg-[#243a58] transition-colors"
                data-testid={`next-${puzzle.id}`}>
                Défi suivant <ArrowRight className="w-3.5 h-3.5" />
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default function ScribbleDefiMots() {
  const [activeLevel, setActiveLevel] = useState('A1');
  const cardRefs = useRef({});

  const puzzles = PUZZLES[activeLevel] || [];

  const scrollToNext = (currentIndex) => {
    const nextId = puzzles[currentIndex + 1]?.id;
    if (nextId && cardRefs.current[nextId]) {
      cardRefs.current[nextId].scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="bg-[#FAF7F0] min-h-screen">
      <section className="pt-16 pb-8">
        <div className="max-w-[520px] mx-auto px-8 text-center">
          <Link to="/speaking-lab" className="inline-flex items-center gap-1 text-xs text-[#999] hover:text-[#D4AF37] transition-colors mb-4" data-testid="back-to-lab">
            <ArrowRight className="w-3 h-3 rotate-180" /> Speaking Lab
          </Link>
          <h1
            className="text-2xl sm:text-3xl font-bold text-[#1A2F4A] mb-2"
            style={{ fontFamily: "'Playfair Display', serif" }}
            data-testid="page-title">
            Scribble : Défi de mots
          </h1>
          <div className="flex items-center justify-center gap-3 mb-3">
            <div className="h-px w-8 bg-[#D4AF37]/50" />
            <PenTool className="w-4 h-4 text-[#D4AF37]/60" />
            <div className="h-px w-8 bg-[#D4AF37]/50" />
          </div>
          <p className="text-xs text-[#6B4E37] italic">
            Forme le maximum de mots avec les lettres données.
          </p>
        </div>
      </section>

      {/* Level Tabs */}
      <section className="pb-4">
        <div className="max-w-[520px] mx-auto px-8 flex gap-2 justify-center" data-testid="level-tabs">
          {LEVELS.map(lvl => {
            const hasContent = (PUZZLES[lvl] || []).length > 0;
            return (
              <button
                key={lvl}
                onClick={() => { if (hasContent) setActiveLevel(lvl); }}
                className={`px-4 py-2 rounded-full text-xs font-bold transition-all ${
                  activeLevel === lvl
                    ? 'bg-[#1A2F4A] text-white'
                    : hasContent
                      ? 'bg-white border border-[#E8E4DC] text-[#1A2F4A] hover:border-[#D4AF37]'
                      : 'bg-[#F3F4F6] text-[#ccc] cursor-not-allowed'
                }`}
                data-testid={`level-btn-${lvl}`}>
                {lvl} {!hasContent && <span className="text-[9px] ml-0.5 opacity-60">soon</span>}
              </button>
            );
          })}
        </div>
      </section>

      {/* Progress */}
      <section className="pb-4">
        <div className="max-w-[520px] mx-auto px-8 text-center">
          <p className="text-[10px] text-[#999]">{puzzles.length} défis disponibles</p>
        </div>
      </section>

      {/* Content */}
      <section className="pb-20">
        <div className="max-w-[520px] mx-auto px-8">
          {puzzles.length === 0 ? (
            <div className="text-center py-16">
              <PenTool className="w-8 h-8 text-[#E8E4DC] mx-auto mb-3" />
              <p className="text-sm text-[#999]">Contenu {activeLevel} bientôt disponible</p>
            </div>
          ) : (
            <div className="space-y-4" data-testid="puzzle-list">
              {puzzles.map((pz, i) => (
                <div key={pz.id} ref={el => { cardRefs.current[pz.id] = el; }}>
                  <PuzzleCard
                    puzzle={pz}
                    index={i}
                    onNext={() => scrollToNext(i)}
                    isLast={i === puzzles.length - 1}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
